import { render, staticRenderFns } from "./Beratungsauftrag.vue?vue&type=template&id=654b1df6"
import script from "./Beratungsauftrag.vue?vue&type=script&lang=js"
export * from "./Beratungsauftrag.vue?vue&type=script&lang=js"
import style0 from "./Beratungsauftrag.vue?vue&type=style&index=0&id=654b1df6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports